import pkg from '../../package.json';

export default {
  address: {
    contactNumberLength: 0,
    contactNumberMinLength: 0,
    contactNumberStartWithZero: false,
    emailRequired: true,
    hidePin: true,
    hideCountry: true,
    fixCountry: '',
    pinCodeRequired: false,
    pinCodeLength: 0,
    pinCodeDigitOnly: false,
    addressLine2Mandatory: false,
    provinces: {
      isShow: false,
      isSelectable: false,
      isMandatory: false,
      isAutoPickFromPincode: false,
    },
    countryCode: '',
  },
  allowInsufficientPoint: false,
  allowMultipleEvoucherRedemptions: true,
  showQty: true,
  allowPayment: false,
  app: 'pwa',
  applyBgColorFromDjango: true,
  appName: 'CerraPoints',
  orgSlug: '',
  isUserRewardPreferenceEnabled: false,
  afterLoginConsentBox: {
    isFullContent: false,
    content: '',
  },
  appreciate: {
    label: 'common.thanks',
    backButtonRoute: 'feeds',
    isDefaultTabAll: false,
  },
  appreciation: {
    autoReflectCcUser: true,
  },
  contactInfo: {
    en: '',
    zn_HK: '',
  },
  contactEmail: '',
  contactNumber: '',
  customFeeds: false,
  customHomeRoute: null,
  customRewardCategory: false,
  customWelcome: false,
  consentText: true,
  debug: {
    api: {
      showFailedStatusCodeInToastr: false,
      showFailedStatusCodeInBrowserConsole: false,
    },
  },
  defaultBgColor: '#202970',
  defaultCurrency: '',
  defaultNationality: { name: '', code: '' },
  defaultLanguage: 'en',
  disableRegisterBtn: false,
  enforceDefaultLanguage: false,
  defaultUserIcon: '',
  downloadNominationCertificate: false,
  drawerBtnLabel: 'common.filter._1',
  electricityTopup: {
    numberOfDigits: 11,
  },
  giftRedemption: false,
  employeeIdPrefix: '',
  enableNomination: true,
  expiryPoint: false,
  expiringPointQueryString: '',
  fallbackRewardIcon: 'assets/img/fallback-rewards.png',
  feeds: {
    label: 'common.feeds',
    path: 'feeds',
    postPolls: false,
  },
  filters: {
    country: true,
  },
  filterByPoints: true,
  filterByRating: false,
  loginPoweredByText: false,
  merchantNRewardsLink: null,
  footer: {
    dynamicLogo: true,
    logoLink: '',
    privacyLink: '/about/privacy',
    tncLink: '/about/terms-of-use',
    userGuide: '',
    showContactUS: true,
    showStaticContactUS: false,
    showResource: false,
    showAbout: true,
    showContactUsMsg: false,
    getContactDetailsFromOrg: false,
    faqLink: '',
    redemptionGuideLink: '',
    showFooterOrgText: false,
    showAboutRewardz: false,
    showVersionAsHeading: true,
  },
  forgotPassword: {
    emailPatternRequired: true,
    mobileNumberRequired: false,
    emailRequired: true,
    employeeIdRequired: false,
  },
  formatHtml: true,
  freshchat: {
    isShow: true,
    pages: 'all',
    script: '//fw-cdn.com/11344154/4030384.js',
    chat: false,
    tags: ['cerra_web'],
  },
  supportChat: {
    isShow: false,
    link: '',
  },
  forgotPasswordLink: true,
  greeting: {
    showYearOfBirth: true,
  },
  goToSsoLinkOnLogout: false,
  header: {
    dynamicBg: true,
    dynamicLogo: true,
    firstLogo: true,
    secondLogo: '',
    pointDetail: false,
    notification: true,
    showDepartmentInProfile: false,
    isIconSvg: true,
    showProfile: true,
    blackIconForNotification: false,
  },
  headerLogoMaxHeight: '48px',
  hideRewardsTnC: false,
  hideSFStoreSFLocker: true,
  home: {
    recommendation: true,
    showRewardsOnHomePage: false,
  },
  infiniteStockEVoucher: false,
  introIcon: 'assets/img/panasonic.png',
  isExternalUrlLoginSupport: true,
  isSiteUnderMaintenance: false,
  isSSOLoginSupport: false,
  isPushNotificationSupport: false,
  isSetNewPassword: false,
  krisFlyerTnC:
    'https://www.singaporeair.com/en_UK/ppsclub_krisflyer/termsconditions-kf/',
  languageAvailable: [
    'ar',
    'en',
    'es',
    'fr',
    'hi',
    'id',
    'ja',
    'km',
    'ko',
    'nl',
    'th',
    'vi',
    'zh-hant',
    'zh-hans',
  ],
  languageLabel: {
    ar: 'العربية',
    en: 'English',
    es: 'Español',
    fr: 'Français',
    hi: 'हिंदी',
    id: 'Indonesia',
    ja: '日本語',
    km: 'ខ្មែរ',
    ko: '한국인',
    nl: 'Nederlands',
    th: 'แบบไทย',
    vi: 'Tiếng Việt',
    'zh-hant': '繁體中文',
    'zh-hans': '粵語',
  },
  rtlLang: ['ar'],
  bottomMenu: ['home', 'settings'],
  showSettingsInMenu: true,
  leftNavigate: [
    'home',
    'feeds',
    'rewards',
    'receipts',
    'quicklink',
    'sales-receipts',
    'flexiBenefits',
    'leaderboard',
    'settings',
  ],
  loginTypesItems: [],
  orderOfMenuItems: [
    'home',
    'appreciate',
    'nomination',
    'feeds',
    'rewards',
    'my-wallet',
    'point-history',
    'receipts',
    'sales-receipts',
    'flexiBenefits',
    'calendar',
    'quicklink',
    'announcement',
    'event',
    'leaderboard',
    'quiz',
    'quest',
    'settings',
  ],
  isShowAnnouncementEvents: false,
  showAnnouncementsExplicitly: false,
  showOverallAnnouncements: false,
  links: {
    sfLocker: '#',
    sfStore: '#',
  },
  loginModal: false,
  loginPage: true,
  loginReadMore: false,
  loginTermsCondition: false,
  topTierRewards: false,
  loginViaUserName: true,
  mobileTopup: {
    mobileNumberMaxDigit: 11,
    mobileNumberMinDigit: 6,
  },
  modules: {
    home: true,
    appreciate: true,
    feeds: true,
    rewards: true,
    myWallet: false,
    settings: true,
    pointsHistory: false,
    cart: true,
    receipts: true,
    salesReceipts: true,
    leaderboard: true,
    flexiBenefits: true,
    calendar: false,
    quicklink: true,
    quiz: true,
    quest: true,
  },
  goToAdminDashboard: true,
  myFeeds: {
    approvals: true,
    myRecommendations: true,
  },
  myNominations: {
    useMergeList: false,
  },
  myWallet: {
    filter: {
      category: 'multiple',
      status: 'single',
    },
  },
  nomination: {
    approvalComment: true,
    badge: true,
    messageToReviewer: true,
    ccUser: true,
    privacy: true,
    preview: true,
    term: false,
  },
  panel: {
    link: ['/profile'],
    support: false,
    signOut: true,
    viewProfile: true,
    dealerManagement: false,
    showDepartment: false,
  },
  passwordValidationPattern:
    '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-zd$@$!%*?&].{8,}',
  pointDetailTitle: 'common.point.n',
  pointDetailHeader: 'common.pointsEarned',
  pointHistoryShowPointSideBySide: true,
  profileEdit: {
    changeAvatar: false,
    changePicDisabled: false,
    editFormDisabled: false,
    navigateToHome: true,
    departmentName: false,
    officialTitle: true,
    taxId: false,
    taxPercentage: false,
    registrationDate: false,
    addressLine1Mandatory: false,
    addressLine2Mandatory: false,
    showEditIcon: true,
    phoneNumberDisabled: false,
    firstNameDisabled: false,
    lastNameDisabled: false,
    address2Disabled: false,
  },
  pointHistoryFilters: {
    pointType: true,
    pointCategory: true,
  },
  randomizeRecommendation: false,
  rating: true,
  recentRecognition: false,
  receipt: {
    showBenefitFor: true,
    showRemarks: true,
    showUserGuide: false,
    prefillBenefitFor: false,
    prefillBenefitCategory: false,
  },
  showTierOnRewards: false,
  recognitionRecommendation: false,
  redeemedSection: 'no-margin-bottom',
  registerNewAccount: true,
  registrationCompletedImg: 'assets/img/mail.png',
  remainingBudgetPoint: false,
  removeRewardRedemption: false,
  rewards: {
    detailQty: 1,
    seeAll: {
      subcategory: 'drawer',
    },
    filters: {
      points: true,
      pointsCollapsible: true,
      rating: true,
      MAX_POINTS: null,
      favorites: true,
      sortByName: true,
      sortByPoint: true,
      sortByLatest: true,
      sortByPopularity: true,
      showFeaturedRewards: true,
      featuredRewardsOnTop: true,
    },
    showDefaultTab: '',
    maxQty: 5,
    maxQtyCart: 10,
    sorting: true,
    title: 'common.reward.n',
    showRewardStock: true,
    showResultsCount: true,
    showValidUntil: true,
    showValidUntilOnEvouchers: true,
    showEvoucherCode: true,
    showStaticRedemptionText: false,
    showStaticTnC: false,
    showSubCatsInFilters: true,
    specialDealRedirection: false,
    showProductSummary: true,
  },
  rewardDefaultSort: 'points',
  rewardDetailBackRoute: ['/rewards/browse-all'],
  search: { helpHeader: '', helpTitle: '', helpDesc: '' },
  searchSubcategory: true,
  registerWithEmployeeId: true,
  registerWithEmail: false,
  registerWithLineId: false,
  settings: {
    hideMyAppreciationMessagesToggle: true,
    makeMyBirthdayPublicToggle: true,
    makeMyAnniversaryPublicToggle: true,
    makeMyProfilePublicToggle: true,
    passwordChangeShow: true,
    changeLanguageShow: true,
    passwordChangeStyle: 'float',
    showRewardPreferences: true,
  },
  showBottomMenu: true,
  showActiveDotInBottomMenu: true,
  showDepartmentName: false,
  showEmployeeId: false,
  showFooter: '1',
  showFooterContactUsDialog: false,
  showPointCategories: false,
  showPoints: true,
  showPointsOnMyWallet: true,
  showPointsOnHome: {
    available: true,
    pointsAtStartOfYear: true,
    earned: true,
    redeemed: true,
    showCurrencyWithPoints: false,
    showYearlyExpiringPoints: false,
    showExpiringPoints: true,
  },
  showLanguageChangeIcon: true,
  showBackButton: true,
  showPageSize: true,
  showServiceBanner: false,
  showSpecialDeal: true,
  showUsername: true,
  showRememberMe: false,
  showRegistrationPointsPage: false,
  showDeliveryFeeApplicableAlert: true,
  sideCarousel: [
    {
      img: 'assets/img/slider/1.png',
    },
    {
      img: 'assets/img/slider/2.png',
    },
    {
      img: 'assets/img/slider/3.png',
    },
  ],
  signUpCode: '',
  skipPassword: true,
  staticBanner: false,
  strengthName: 'Strength',
  isSupportedMediaInComment: false,
  thankMessageLeftBox: false,
  tips: {
    count: 10,
    select: null,
  },
  topMenu: false,
  transactionHistoryRewardNameTranslatable: false,
  unauthorizedErrorMessage:
    'Please close this window and click the reward button again from Line OA.',
  useExternalUrlLoginOnly: false,
  ver: pkg.version,
  verShow: false,
  voucherStatus: [0, 1, 2, 9, 11],
  whoToThankTab: false,
  zhLang: 'zh-hant',
  showJobFamily: false,
  userRegistration: {
    contactNumberMinLength: 0,
    contactNumberMaxLength: 0,
  },
  enableHeuristics: false,
  salesReceiptFormItems: {
    orderNum: false,
    cashier: false,
    itemDetails: {
      brand: true,
      subCategory: true,
      brandModel: true,
      quantity: true,
      amount: true,
    },
    showDetails: {
      brand: true,
      category: false,
      subCategory: true,
      brandModel: true,
      quantity: true,
      amount: true,
    },
    itemsMap: {},
    area: false,
    distributor: false,
  },
  showReceiptNumOnTransactions: false,
  showSessionTimer: false,
  showSessionTimerNote: false,
  showBackToWebsiteBtn: false,
  showAppreciationMsgText: false,
  // Remove this once bottom menu fix is done
  showMoreButtonInBottomMenu: true,
  showMobileTimer: false,
  isExternalLogin: false,
  syncPoints: false,
  showWelcomeGift: false,
  showBirthdayGift: false,
  showRedeemedBirthdayGifts: false,
  showBreadCrumb: true,
  showRedemptionYears: true,
  showOnlyPastYearRedemptions: false,
  dashboardData: {
    showOnlyFeaturedRewards: false,
    showOnlyTopRewards: false,
    showDiscountsInTopRewards: false,
    showDiscountsInFeaturedRewards: false,
  },
  // Remove this setting once there is final design for floating button
  showFloatingBtnFromLayout: true,
  // White Label Specific
  provinces: {},
  pageSizes: {
    web: [12, 21, 51],
    mobile: [10, 20, 30],
  },
  termsOfUsePoint: [],
  isShowQuiz: false,
  isShowQuest: false,
  organizations: [],
  privacyPolicyUrl: '',
  installPWA: true,
};
